export default "__VITE_ASSET__0da53086__"